<template>
  <v-dialog v-model="dialog" width="400px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title color="red">Xoá {{ removeStudents.length }} học sinh ?</v-card-title>
      <v-card-text>
        Thao tác này không thể hoàn tác. Bạn có chắc chắn muốn xóa học sinh ({{ studentNames }}) ?
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn depressed class="red white--text" @click="onDelete()">Xoá</v-btn>
        <v-btn depressed outlined @click="cancel()">Huỷ</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  components: {},
  props: {
    state: Boolean,
    busStop: {
      type: Object,
      default: () => {}
    },
    removeStudents: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialog: false,
      loading: false
    }
  },
  computed: {
    studentNames() {
      return this.removeStudents.map(s => s.name).join(', ')
    }
  },
  methods: {
    ...mapActions('busDetail', ['deleteStudentBusStop']),
    async onDelete() {
      try {
        this.$loading.active = true
        const idStudents = this.removeStudents.map(item => item.id)
        await this.deleteStudentBusStop({ id: this.busStop.id, students: idStudents })
        this.$alert.deleteSuccess()
        this.dialog = false
        this.$emit('done')
      } catch (error) {
        this.$alert.deleteError()
      } finally {
        this.$loading.active = false
      }
    },
    cancel() {
      this.dialog = false
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
